import { useEffect, useState } from 'react';

/**
 * localStorage 에 자동 보존되는 useState.
 * 탭 전환 / 페이지 이탈 후 돌아와도 값 유지.
 *
 * Phase 55: 부운영자 시드 입력이 페이지 이탈 시 사라지는 문제 해결.
 */
export function useLocalStorageState(
  key: string,
  initial: string,
): [string, (v: string) => void] {
  const [value, setValue] = useState<string>(() => {
    if (typeof window === 'undefined') return initial;
    try {
      const raw = window.localStorage.getItem(key);
      return raw ?? initial;
    } catch {
      return initial;
    }
  });

  useEffect(() => {
    try {
      if (value) window.localStorage.setItem(key, value);
      else window.localStorage.removeItem(key);
    } catch {
      /* quota / disabled */
    }
  }, [key, value]);

  return [value, setValue];
}
